<template>
<div class="main">
    <div>
        <DiamondQuizTitle @closePage="emitclosePage"/>
    </div>

    <div class="message">
        <DiamondQuizDiamondMessage message="Let us help you find the perfect diamond."/>
    </div>

    <div class="d-flex justify-content-center align-items-center flex-column">
        <button :class="{'disabled': isLoading}" class="button text-center" @click="gotToNextPage" :disabled="isLoading">
            <span v-if="isLoading">Please wait...</span>
            <span v-else>proceed</span>
        </button>
        <DiamondQuizFooter />
    </div>
</div>
</template>

<script setup>
import { diamondQuizStore } from '@/stores/diamond_quiz/diamond_quiz';

const store = diamondQuizStore()
const isLoading = ref(false)

const emit = defineEmits(['close'])

const gotToNextPage = async () => {
    try {
        isLoading.value = true

       await store.setBudgetMinMax()
       
    } finally{
        isLoading.value = false
        store.setNextPage()
    }

   

}

const emitclosePage = () => {
    emit('close')
}


</script>

<style scoped>
/* .main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 90vh;
    overflow: auto;
    overflow-x: hidden;
} */

/* .message {
    padding: 20% 0;
} */

/* .content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20% 0;
} */



/* .dialog_box {
    font-size: 18px;
    font-style: italic;
    color: #405955;
    border: 1px solid var(--green);
    border-radius: 4px;
    padding: 10px;
} */
.button {
    padding: 14px 30px;
    border: 1.5px solid var(--green);
    border-radius: 4px;
    width: 40%;
    margin: 0 auto;
    background: var(--green);
    cursor: pointer;
    margin-bottom: 3%;
}

.button span {
    font-size: 14px;
    letter-spacing: 1.4px;
    font-weight: 700;
    color: #fff;
    text-transform: uppercase;
}

button.disabled{
    cursor: auto;
    opacity: 0.7;
}


@media(max-width:992px){
    /* .content img {
        width: 100px;
        height: 100px;
    }
    .dialog_box {
        font-size: 16px;
    } */

    .button {
        width: 60%;
        padding: 10px 15px;
    }

}

@media(max-width:768px) {
    /* .content img {
        width: 80px;
        height: 80px;
    }

    .dialog_box {
        font-size: 14px;
    } */

    .button {
        width: 96%;
        /* padding: 14px 30px; */
    }

    .main {
        height: 50vh;
    }

    
}
</style>